export default __webpack_public_path__ + "static/media/doughnut-3.49702107.jpeg";